import styled from "styled-components";

export const CheckupPageStyle = styled.div`

`;

export const CheckboxWrapper = styled.div`
    margin-right: 2em;
`;
